module.exports = __webpack_public_path__ + "static/media/yaaa_chandrabindu.4935f527.ogg";